import styled, { css } from 'styled-components';
import { theme } from '../themes';


const _inputStyle = css`
  height: 40px;
  border: 1px solid var(--color-gray-regular);
  border-radius: 4px;
  color: var(--color-primary);
  background-color: white;
  &:focus {
    outline: none;
    border: 1px solid var(--color-secondary);
  }

  &:disabled{
    color: #000000;
    background-color: #e9e9e9;
  }
  
`

const _optionStyle = css`
  position: relative;
  top: -1px;
  margin: 3px;
`

export const baseMessageStyle = css`
  text-align: center;
  display: block;
  padding: 8px;
  font-size: 16px;
  border-width: 1px;
  border-style: solid;
  border-radius: var(--base-border-radius);
`

export const errorMessageStyle = css`
  ${baseMessageStyle}
  border-color: var(--color-danger);
  color: var(--color-danger);
`

export const labelStyle = css`
  display: block;
  margin-bottom: 8px;
`

export const selectStyle = css`
  padding: 0 6px;
  ${_inputStyle}
`

export const textAreaStyle = css`
  ${_inputStyle}
`

export const baseInput = css`
  &[type="radio"]  {
    ${_optionStyle}
  }
  &[type="text"], &[type="number"], &[type="email"], &[type="password"], &[type="url"], &[type="date"], &[type="tel"]  {
    padding: 4px 8px;
    ${_inputStyle}
  }
`

export const altInput = css`
  &[type="radio"], input[type="checkbox"] {
    ${_optionStyle}
  }
  &[type="text"], &[type="number"], &[type="email"], &[type="password"], &[type="url"], &[type="date"], &[type="tel"]  {
    width: 100%;
    padding: 4px;
    outline: 0;
    border-width: 0 0 2px;
    border-color: var(--color-primary);
    color: var(--color-primary);
    font-weight: var(--font-weight-medium);
    background-color: transparent;
    &:focus {
      border-color: var(--color-secondary);
    }
    &::placeholder {
      color: var(--color-primary);
      font-weight: var(--font-weight-medium);
    }
  }
`
